import { post } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,impDriverStandingBookExcel
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
var name = global.driverNameT
var signature = global.signature
// 司机查询
export const cDlist = p => post(name + '/cDriverInfo/list', p)
// 司机添加
export const cDadd = p => post(name + '/cDriverInfo/addPc', p)
// 司机修改
export const cDupdate = p => post(name + '/cDriverInfo/updatePC', p)
// 司机删除
export const cDdelete = p => post(name + '/cDriverInfo/delete', p)
// 车辆查询
export const cVIlist = p => post(name + '/cVehicleInfo/list', p)
// 车辆添加
export const cVIadd = p => post(name + '/cVehicleInfo/addPC', p)
export const cVIaddD = p => post(name + '/cDriverVehicleRel/addDriverVehicle', p)
// 车辆导入
export const impVehicleInfoExcel = p => post(name + '/cVehicleInfo/impVehicleInfoExcel', p)
// 车辆修改
export const cVIupdate = p => post(name + '/cVehicleInfo/updatePC', p)

// 车辆删除
export const cVIdelete = p => post(name + '/cVehicleInfo/delete', p)
// 车长查询
export const cVLlist = p => post(name + '/cVehicleLong/list', p)
// 车长添加
export const cVLadd = p => post(name + '/cVehicleLong/add', p)
// 车长修改
export const cVLupdate = p => post(name + '/cVehicleLong/update', p)
// 车长删除
export const cVLdelete = p => post(name + '/cVehicleLong/delete', p)
// 车辆类型查询
export const cVTlist = p => post(name + '/cVehicleType/list', p)
// 车辆类型添加
export const cVTadd = p => post(name + '/cVehicleType/add', p)
// 车辆类型修改
export const cVTupdate = p => post(name + '/cVehicleType/update', p)
// 车辆类型删除
export const cVTdelete = p => post(name + '/cVehicleType/delete', p)
// 使用性质列表
export const cVPlist = p => post(name + '/cVehiclePurpose/list', p)
// 使用性质添加
export const cVPadd = p => post(name + '/cVehiclePurpose/add', p)
// 使用性质修改
export const cVPupdate = p => post(name + '/cVehiclePurpose/update', p)
// 使用性质删除
export const cVPdelete = p => post(name + '/cVehiclePurpose/delete', p)
// 车辆排放标准列表
export const cVElist = p => post(name + '/cVehicleEmissionStandards/list', p)
// 车辆排放标准添加
export const cVEadd = p => post(name + '/cVehicleEmissionStandards/add', p)
// 车辆排放标准修改
export const cVEupdate = p => post(name + '/cVehicleEmissionStandards/update', p)
// 车辆排放标准删除
export const cVEdelete = p => post(name + '/cVehicleEmissionStandards/delete', p)
// 获取车辆信息
export const getCVehicleInfo = p => post(name + '/cVehicleInfo/getCVehicleInfo', p)
// 获取司机信息
export const getCDriverInfo = p => post(name + '/cDriverInfo/getCDriverInfoPC', p)
// 开通账号
export const openAccount = p => post(name + '/cDriverAccount/openAccount', p)
// 车辆台账导入
export const impDriverStandingBookExcel = p => post(name + '/driverStandingBook/impDriverStandingBookExcel', p)
// 车辆台账数据查询
export const getDriverStandingBookPage = p => post(name + '/driverStandingBook/getDriverStandingBookPage', p)
// 所属司机下拉
export const getRelationCustomerFleet = p => post(name + '/cVehicleInfo/getRelationCustomerFleet', p)
// 司机修改
export const detailDriver = p => post(name + '/cDriverInfo/detailDriver', p)
// 添加银行卡
export const CDBadd = p => post(name + '/cDriverBankCard/add', p)
// 修改银行卡
export const CDBupdate = p => post(name + '/cDriverBankCard/update', p)
// 设置默认
export const updateDefault = p => post(name + '/cDriverBankCard/updateDefault', p)
// 银行卡列表
export const CDBlist = p => post(name + '/cDriverBankCard/list', p)
// 银行卡删除
export const CDBdelete = p => post(name + '/cDriverBankCard/delete', p)
// 指派司机列表//平台1 车队2 货主3
export const assignDriverList = p => post(name + '/cDriverInfo/assignDriverList', p)
// 指派车辆列表
export const getCVehicleInfoListByDriverId = p => post(name + '/cVehicleInfo/getCVehicleInfoListByDriverId', p)
// 能源类型列表
export const cVhcEnergyTypeList = p => post(name + '/cVhcEnergyType/list', p)
// 车牌颜色列表
export const cVhcNoColourList = p => post(name + '/cVhcNoColour/list', p)
// 根据司机id查车辆列表（所有车辆）配货端用
export const getCVehicleExtAllByDriverId = p => post(name + '/cVehicleInfo/getCVehicleExtAllByDriverId', p)
// 根据司机id查车辆列表（所有车辆）海运系统用
export const getCVehicleInfoAllByDriverId = p => post(name + '/cVehicleInfo/getCVehicleInfoAllByDriverId', p)
// 根据车牌号查司机
export const getCDriverInfoListByVhcNo = p => post(name + '/cDriverInfo/getCDriverInfoListByVhcNo', p)
// 根据车队长查司机
export const assignCaptainDriverList = p => post(name + '/cDriverInfo/assignCaptainDriverList', p)
// 挂靠声明
export const getStatementByVchId = p => post(name + '/cVehicleStatement/getStatementByVchId', p)
// 运力列表
export const transportCapacityList = p => post(name + '/cDriverVehicleRel/transportCapacityList', p)
// 运力新增
export const cDriverVehicleRelAdd = p => post(name + '/cDriverVehicleRel/add', p)
// 运力上传
export const insertFile = p => post(name + '/cDriverVehicleRel/insertFile', p)
// 运力删除
export const cDriverVehicleRelDelete = p => post(name + '/cDriverVehicleRel/delete', p)
// 运力提交
export const CDVsubmitRel = p => post(name + '/cDriverVehicleRel/submitRel', p)
// 找车列表
export const driverFound = p => post(name + '/driverFound/list', p)
// 找车详情
export const tenantDriverLogDetail = p => post(name + '/tenantDriverLog/detail', p)
// 找车记录
export const carSearchRecord = p => post(name + '/tenantDriverLog/list', p)
// 常走路线添加（平）
export const cUsualLineAdd = p => post(name + '/cUsualLine/add', p)
// 常走路线修改（平）
export const cUsualLineUpdate = p => post(name + '/cUsualLine/update', p)
// 常走路线删除（平）
export const cUsualLineDelete = p => post(name + '/cUsualLine/delete', p)
// 常走路线列表（平）
export const cUsualLineList = p => post(name + '/cUsualLine/list', p)
// 设置偏好货物（平）
export const addOrUpdate = p => post(name + '/cPreferenceGoods/addOrUpdate', p)
// 偏好货物列表（平）
export const cPreferenceGoodsList = p => post(name + '/cPreferenceGoods/list', p)
// 货主端 基础信息-长协车队 列表（平）
export const selectTenantLongCarriageList = p => post(name + '/api/selectTenantLongCarriageList', p)
// 货主端 发布货源-排放标准（平）
export const cVehicleEmissionStandards = p => post(name + '/cVehicleEmissionStandards/list', p)
// 货主端 发布货源-能源类型（平）
export const cVhcEnergyType = p => post(name + '/cVhcEnergyType/list', p)
// 司机端账号列表（平）
export const cDriverAccountList = p => post(name + '/cDriverAccount/list', p)
// 司机端账号删除（平）
export const deleteAccount = p => post(name + '/cDriverAccount/deleteAccount', p)
// 司机端账号-变更账号（平）
export const updateAccount = p => post(name + '/cDriverAccount/updateAccount', p)
// 车队端新增接口（常）
export const fleetVehicleList = p => post(name + '/cVehicleInfo/fleetVehicleList', p)// 车队端车辆列表
export const fleetAddVehicle = p => post(name + '/cVehicleInfo/fleetAddVehicle', p)// 车队端关联车辆
export const fleetDriverList = p => post(name + '/cDriverInfo/fleetDriverList', p)// 车队端司机列表
export const fleetAddDriver = p => post(name + '/cDriverInfo/fleetAddDriver', p)// 车队端关联司机
// 司机解绑（常）
export const fleetDelDriver = p => post(name + '/cDriverInfo/fleetDelDriver', p)
// 车辆解绑（常）
export const fleetDelVehicle = p => post(name + '/cVehicleInfo/fleetDelVehicle ', p)
// 官网海量车源接口(亚)
export const massiveVehicleSourcesList = p => post(name + '/cDriverInfo/massiveVehicleSourcesList', p)
// 官网注册车辆/注册司机(亚)
export const registeredInfo = p => post(name + '/cDriverInfo/registeredInfo', p)

// 自有司机
// 司机查询
export const cDlists = p => post(name + '/cDriverInfo/lists', p)
// 司机添加
export const cDadds = p => post(name + '/cDriverInfo/addPcs', p)
// 司机修改
export const cDupdates = p => post(name + '/cDriverInfo/updatePCs', p)
// 司机绑定承运商
export const driverBindCustomer = (p) => post(name + '/cDriverInfo/driverBindCustomer', p)
// 司机删除
export const cDdeletes = p => post(name + '/cDriverInfo/deletes', p)
// 车辆查询
export const cVIlists = p => post(name + '/cVehicleInfo/lists', p)
// 车辆添加
export const cVIadds = p => post(name + '/cVehicleInfo/addPCs', p)
// 车辆修改
export const cVIupdates = p => post(name + '/cVehicleInfo/updatePCs', p)
// 车辆删除
export const cVIdeletes = p => post(name + '/cVehicleInfo/deletes', p)

// 运营方人车组织机构树
export const organizationTree = p => post(name + '/cOperationOrganization/organizationTree', p)
// 新增运营方人车组织机构树
export const addOperationOrganization = p => post(name + '/cOperationOrganization/addOperationOrganization', p)
// 修改运营方人车组织机构树
export const updateOperationOrganization = p => post(name + '/cOperationOrganization/updateOperationOrganization', p)
// 删除运营方人车组织机构树
export const deleteOperationOrganization = p => post(name + '/cOperationOrganization/deleteOperationOrganization', p)
// ocr接口
export const ocrIdentification = (p) => post(signature + '/api/ocrIdentification', p)
// ocr接口自定义
export const ocrCustomModelByFile = (p) => post(signature + '/api/ocrCustomModelByFile', p)
// ocr模板管理列表
export const ocrModelList = p => post(`/${signature}/api/ocrModelList`, p)
// 拉黑司机
export const addBlackLists = p => post(name + '/cDriverInfo/addBlackLists', p)
// 拉黑司机
export const delBlackLists = p => post(name + '/cDriverInfo/delBlackLists', p)
// 拉黑车辆
export const addBlackList = p => post(name + '/cVehicleInfo/addBlackLists', p)
// 拉黑司机
export const VdelBlackList = p => post(name + '/cVehicleInfo/delBlackLists', p)
// 查询司机账号表信息
export const getDriverAccount = p => post(name + '/cDriverAccount/getDriverAccount', p)
// 查询计划可派车车牌号司机列表
export const getVehicleDriverListByDh = p => post(name + '/cDriverVehicleRel/getVehicleDriverListByDh', p)
// 查询子组织
export const cOperationOrganizationList = p => post(name + '/cOperationOrganization/list', p)
// 人车绑定  司机下拉
export const getDriverListByDh = p => post(name + '/cDriverVehicleRel/getDriverListByDh', p)
// 人车绑定  车辆下拉
export const getVehicleListByDh = p => post(name + '/cDriverVehicleRel/getVehicleListByDh', p)
export const getDriverBanciList = p => post(name + '/cDriverVehicleRel/getDriverBanciList', p)
// 运力删除 人车绑定  司机车辆解绑
// export const cDriverVehicleRelDelete = p => post(name + '/cDriverVehicleRel/delete', p)
// 司机绑定默认车辆
export const bindDefaultVehicle = p => post(name + '/cDriverVehicleRel/bindDefaultVehicle', p)
// 司机修改默认车辆
export const updateDefaultVehicle = p => post(name + '/cDriverVehicleRel/updateDefaultVehicle', p)
// 车辆详细信息
export const cVehicleInfoDetail = p => post(name + '/cVehicleInfo/detail', p)
// 车辆调拨
export const cVehicleInfoDiaobos = p => post(name + '/cVehicleInfo/diaobos', p)
// 司机调拨
export const cDriverInfoDiaobo = p => post(name + '/cDriverInfo/diaobo', p)
// 主车帮车
export const updateTrailers = p => post(name + '/cVehicleInfo/updateTrailers', p)
// 查询预警天数配置
export const tOverdueSetList = p => post(`${name}/tOverdueSet/list`, p)
export const tOverdueSetUpdate = p => post(`${name}/tOverdueSet/update`, p)// 更新预警配置

export const detailDrivers = p => post(name + '/cDriverInfo/detailDrivers', p)

// 司机考勤
export const cDriverWorkRecordListPC = p => post(`${name}/cDriverWorkRecord/listPC`, p)// 上班记录查询
export const cDriverHolidayRecordListPC = p => post(`${name}/cDriverHolidayRecord/listPC`, p)// 请假记录查询
export const delHolidayRecord = p => post(`${name}/cDriverHolidayRecord/delHolidayRecord`, p)// 删除请假记录
export const delWorkRecord = p => post(`${name}/cDriverWorkRecord/delWorkRecord`, p)// 删除上班记录
export const upWorkRecordPc = p => post(`${name}/cDriverWorkRecord/upWorkRecordPc`, p)// 修改
export const upWorkRecordForXbPc = p => post(`${name}/cDriverWorkRecord/upWorkRecordForXbPc`, p)// 下班
export const getFileShow = p => post(`${name}/tAttachments/getFileShow`, p)// 查看凭证

// 运力地图
export const orgTree = p => post(`${name}/cVehicleInfo/orgTree`, p)// 车辆树
export const driverVehicleStatus = (p) => post(name + '/cVehicleInfo/driverVehicleStatus', p)// 车辆司机状态
export const cVehiclesRealTimeGpsInfo = (p) => post(name + '//cVehicleGps/cVehiclesRealTimeGpsInfo', p)// 查询多辆车位置
export const vehiclePositionInfo = (p) => post(name + '/cVehicleInfo/vehiclePositionInfo', p)// 查询某一辆车的详情行驶信息、

export const listAllVehicleModels = (p) => post(name + '/cVehicleModel/listAllVehicleModels', p)// 挂车类型
export const listVehicleLengthsByModelId = (p) => post(name + '/cVehicleModel/listVehicleLengthsByModelId', p)// 根据挂车类型查车长

export const getDictionary = (p) => post(name + '/api/getDictionary', p)// 是否上传五证等信息

// 排班管理
export const cDriverQueueList = (p) => post(name + '/cDriverQueue/list', p)// 列表
export const cDriverQueueInvalid = (p) => post(name + '/cDriverQueue/invalid', p)// 作废
export const cAssignmentRecordList = (p) => post(name + '/cAssignmentRecord/list', p)// 操作记录

export const findVehicleInsuranceList = p => post(`${name}/cVehicleInsurance/findVehicleInsuranceList`, p)// 车辆保险查询
export const updateInsurance = p => post(`${name}/cVehicleInsurance/updateInsurance`, p)// 添加、修改、删除车辆保险
export const imporVehicleInsurance = p => post(`${name}/cVehicleInsurance/imporVehicleInsurance`, p)// 车辆保险导入
export const cVehicleInsuranceList = p => post(`${name}/cVehicleInsurance/list`, p)// 车辆id查询保险列表

export const driverResign = (p) => post(name + '/cDriverInfo/driverResign', p)// 司机管理-离职
// 自由车统计
export const statusByTeam = (p) => post(name + '/cVehicleInfo/statusByTeam', p)// 实时出车情况
// 司机保险
export const driverInsuranceList = (p) => post(name + '/driverInsurance/list', p)
export const driverInsuranceUpdateInsurance = (p) => post(name + '/driverInsurance/updateInsurance', p)
export const driverInsuranceImport = (p) => post(name + '/driverInsurance/import', p)
export const driverInsuranceDeletes = (p) => post(name + '/driverInsurance/deletes', p)// 司机保险-商业险删除
// 司机工资
export const cDriverSalaryAdd = (p) => post(name + '/cDriverSalary/add', p)
export const cDriverSalaryUpdate = (p) => post(name + '/cDriverSalary/update', p)
export const cDriverSalaryDelete = (p) => post(name + '/cDriverSalary/delete', p)
export const cDriverSalaryImport = (p) => post(name + '/cDriverSalary/import', p)
export const cDriverSalaryList = (p) => post(name + '/cDriverSalary/list', p)
// 司机社保-列表
export const cDriverShebaoMonthlyList = (p) => post(name + '/cDriverShebaoMonthly/list', p)
// 司机社保-新增
export const cDriverShebaoMonthlyAdd = (p) => post(name + '/cDriverShebaoMonthly/add', p)
// 司机社保-修改
export const cDriverShebaoMonthlyUpdate = (p) => post(name + '/cDriverShebaoMonthly/update', p)
// 司机社保-删除
export const cDriverShebaoMonthlyDelete = (p) => post(name + '/cDriverShebaoMonthly/delete', p)
// 新版车辆保险
export const cVehicleInsuranceNewList = (p) => post(name + '/cVehicleInsuranceNew/list', p)
export const saveOrUpdateWithAttachments = (p) => post(name + '/cVehicleInsuranceNew/saveOrUpdateWithAttachments', p)
export const cVehicleInsuranceNewdelete = (p) => post(name + '/cVehicleInsuranceNew/delete', p)
export const cVehicleInsuranceNewdetail = (p) => post(name + '/cVehicleInsuranceNew/detail', p)
export const cVehicleInsuranceNewimport = (p) => post(name + '/cVehicleInsuranceNew/import', p)
export const cVehicleInsuranceNewdeletes = (p) => post(name + '/cVehicleInsuranceNew/deletes', p)// 批量删除

// merged missing exports from zw56-platform-web
export const VehicleModelAdd = p => post(name + '/cVehicleModel/add', p)
// 基础数据-删除车型
export const VehicleModelDelete = p => post(name + '/cVehicleModel/delete', p)
// 基础数据-编辑车型
export const VehicleModelList = p => post(name + '/cVehicleModel/list', p)
// 基础数据/发布货源-查询全部车型
export const VehicleModelUpdate = p => post(name + '/cVehicleModel/update', p)
// 基础数据-车型查询列表
export const cTransportCapacityAdd = p => post(`${name}/cTransportCapacity/add`, p)
// 货主-私有运力-运力列表-编辑分组
export const cTransportCapacityDelete = p => post(`${name}/cTransportCapacity/delete`, p)
// 货主-私有运力-运力地图-分组树
export const cTransportCapacityList = p => post(`${name}/cTransportCapacity/list`, p)
// 货主-私有运力-运力列表-新增
export const cTransportCapacityUpdate = p => post(`${name}/cTransportCapacity/update`, p)
// 货主-私有运力-运力列表-删除
export const cVehicleRealTimeGpsInfoList = p => post(`${name}/cVehicleGps/cVehicleRealTimeGpsInfoList`, p)
export const carrierAuditDeatil = p => post(name + '/cDriverVehicleRel/carrierAuditDeatil', p)
// 平台端数据对接页面车老板推送
export const findCarrierList = p => post(name + '/cDriverVehicleRel/findCarrierList', p)
// 车老板绑定司机车辆查询详情
export const findDriverTenantRel = p => post(name + '/cDriverTenantRel/findDriverTenantRel', p)
// 平台端数据对接页面获取车辆推送快货运状态
export const findVehicleTenantRel = p => post(name + '/cVehicleTenantRel/findVehicleTenantRel', p)
// 车老板核验页面查询列表
export const getVehiceTypeList = p => post(name + '/cVehicleType/getVehiceTypeList', p)
// 基础数据-新增车型
export const listDriverVehiclePost = p => post(name + '/cDriverVehicleRel/listDriverVehiclePost', p)
// 货主-私有运力-运力分组-列表
export const postCarrierInfoKhyPt = p => post(name + '/api/postCarrierInfoKhyPt', p)
// 数据对接页面-司机协议签署
export const postSignAgreementKhyPt = p => post(name + '/api/postSignAgreementKhyPt', p)
// 车型列表
export const queryGroupVehicleTree = p => post(`${name}/cTransportCapacity/queryGroupVehicleTree`, p)
// 货主-私有运力-运力地图-查询多车实时位置
export const sCapacityGroupAdd = p => post(`${name}/sCapacityGroup/add`, p)
// 货主-私有运力-运力分组-删除
export const sCapacityGroupDelete = p => post(`${name}/sCapacityGroup/delete`, p)
// 货主-私有运力-运力分组-修改
export const sCapacityGroupList = p => post(`${name}/sCapacityGroup/list`, p)
// 货主-私有运力-运力分组-新增
export const sCapacityGroupUpdate = p => post(`${name}/sCapacityGroup/update`, p)
// 货主-私有运力-运力列表-列表
// 调度看板大屏获取车辆小队小组
export const teamVehicleStatistics = p => post(`${name}/cOperationOrganization/teamVehicleStatistics`, p)
// 司机保险 -》  商业险-》实际保费合计
export const driverInsuranceListTotal = p => post(`${name}/driverInsurance/listTotal`, p)
// 车辆保险  交强险合计、商业险合计、合计金额
export const cVehicleInsuranceNewListTotal = p => post(`${name}/cVehicleInsuranceNew/listTotal`, p)
